import * as RTooltip from '@radix-ui/react-tooltip'
import { type ReactNode } from 'react'

// Tooltip — a brief text label for unlabelled icons
// (design/components/overlays.html §5.3). Built on Radix Tooltip: appears on
// hover AND keyboard focus, entry delay / no exit delay, text only (no
// controls). Dark in both themes.

export interface TooltipProps {
  label: string
  children: ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  delayDuration?: number
}

/** Brief text label for unlabelled icons (Radix Tooltip): shows on hover AND
 *  keyboard focus, text only — never controls. `children` is the trigger,
 *  rendered asChild, so pass a focusable element. */
export function Tooltip({ label, children, side = 'top', delayDuration = 300 }: TooltipProps) {
  return (
    <RTooltip.Provider delayDuration={delayDuration}>
      <RTooltip.Root>
        <RTooltip.Trigger asChild>{children}</RTooltip.Trigger>
        <RTooltip.Portal>
          <RTooltip.Content
            side={side}
            sideOffset={6}
            className="z-50 max-w-[220px] rounded-sm bg-[#0F1117] px-[9px] py-1.5 text-[11px] font-medium leading-snug text-white dark:bg-[#2A3038]"
          >
            {label}
            <RTooltip.Arrow className="fill-[#0F1117] dark:fill-[#2A3038]" width={9} height={5} />
          </RTooltip.Content>
        </RTooltip.Portal>
      </RTooltip.Root>
    </RTooltip.Provider>
  )
}
